import * as LoadingStatus from '@coconut/constants/loadingState';

export const types = {
  UPLOAD_IMAGE_REQUEST: 'UPLOAD_IMAGE_REQUEST',
  UPLOAD_IMAGE_SUCCESS: 'UPLOAD_IMAGE_SUCCESS',
  UPLOAD_IMAGE_FAILURE: 'UPLOAD_IMAGE_FAILURE',
};

export const actions = {
  uploadImage: ({ file, desc, subjectId, lang }) => ({
    type: types.UPLOAD_IMAGE_REQUEST,
    payload: {
      file,
      desc,
      subjectId,
      lang,
    },
  }),
  uploadImageSuccess: () => ({ type: types.UPLOAD_IMAGE_SUCCESS }),
  uploadImageFailed: () => ({ type: types.UPLOAD_IMAGE_FAILURE }),
};

const initialState = {
  uploadStatus: LoadingStatus.EMPTY,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        uploadStatus: LoadingStatus.LOADING,
      };
    case types.UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        uploadStatus: LoadingStatus.READY,
      };
    case types.UPLOAD_IMAGE_FAILURE:
      return {
        ...state,
        uploadStatus: LoadingStatus.ERROR,
      };
    default:
      return state;
  }
};

export default reducer;
export const getUploadStatus = (state) => state.uploadImage.uploadStatus;



// WEBPACK FOOTER //
// ./src/scenes/UploadImage/services/redux/uploadImage.js